import { PaginationResponse } from "models/pagination-response";
import { IObraPagedRequest } from "models/request/obra-paged-request";
import { IObraPagedResponse } from "models/response/obra-paged-response";
import { ISituacaoObraResponse } from "models/response/situacao-obra-response";
import { IFuncaoObraResponse } from "models/response/funcao-obra-response";
import { ITipoObraResponse } from "models/response/tipo-obra-response";

export type ObrasState = {
    obras: PaginationResponse<IObraPagedResponse>;
    obraPagedRequest: IObraPagedRequest;
    situacoes: ISituacaoObraResponse[];
    funcoes: IFuncaoObraResponse[];
    tipos: ITipoObraResponse[];
    ultimaAtualizacao: string | null;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setObras = 'setObras',
    setObraPagedRequest = 'setObraPagedRequest',
    setSituacoes = 'setSituacoes',
    setFuncoes = 'setFuncoes',
    setTipos = 'setTipos',
    setUltimaAtualizacao = 'setUltimaAtualizacao',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const ObrasReducer = (state: ObrasState, action: any): ObrasState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setObraPagedRequest:
            return { ...state, obraPagedRequest: payload };
        case ACTION_TYPES.setObras:
            return { ...state, obras: payload };
        case ACTION_TYPES.setSituacoes:
            return { ...state, situacoes: payload };
        case ACTION_TYPES.setFuncoes:
            return { ...state, funcoes: payload };
        case ACTION_TYPES.setTipos:
            return { ...state, tipos: payload };
        case ACTION_TYPES.setUltimaAtualizacao:
            return { ...state, ultimaAtualizacao: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.setError:
            return { ...state, error: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
